import { createContext, useContext } from 'react'

import { FormType } from 'ui/components'
import {
  AnnualReviewSalesDepositsEditMode,
  AnnualReviewSalesDepositsForm
} from '~bank-annual-review/types/SalesDeposits'

type AnnualReviewSalesDepositsContextValue = {
  id: number
  annualReviewId: number
  companyId: number
  data: AnnualReviewSalesDepositsEditMode
  formApi: FormType<AnnualReviewSalesDepositsForm>
  isPending: boolean
  successFullyLoaded: boolean
  backToAnnualReviewDetails: () => void
}

export const AnnualReviewSalesDepositsContext = createContext<AnnualReviewSalesDepositsContextValue | null>(null)

export const useAnnualReviewSalesDepositsContext = () => {
  const context = useContext(AnnualReviewSalesDepositsContext)

  if (!context) {
    throw new Error(
      'useAnnualReviewSalesDepositsContext must be used within a AnnualReviewSalesDepositsContext.Provider'
    )
  }

  return context
}
